
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.008 29l13.595-.017L50 14.506 35.637.029 22.423 0l13.834 14.506L22.007 29z","fill":"#BF3577"}}),_c('path',{attrs:{"d":"M14.425 20.395c-3.236 0-5.864-2.642-5.864-5.895 0-3.253 2.628-5.895 5.864-5.895h14.79L21.012 0h-6.587C6.456 0 0 6.495 0 14.5 0 22.505 6.456 29 14.425 29h6.178l8.458-8.576-14.636-.03z","fill":"#BF3577"}})])
          )
        }
      }
    